import api from "./api";

export interface ManageCoupon {
  id: number;
  title: string;
  code: string | null;
  discount_type: string;
  amount: number;
  status: string;
  start_date_time: string | null;
  end_date_time: string | null;
  uses_limit?: number | null;
  used_time?: number | null;
  remaining_uses?: number | null;
  minimum_purchase_amount?: number | null;
  description?: string | null;
  days?: string | string[] | null;
  created_at?: string;
}

export interface PaginatedResponse<T> {
  current_page: number;
  data: T[];
  last_page: number;
  per_page: number;
  total: number;
}

const unwrapData = <T>(response: any): T => response?.data?.data ?? response?.data;

export const getManageCoupons = async (
  params: Record<string, any> = {},
): Promise<PaginatedResponse<ManageCoupon>> => {
  const response = await api.get("/admin/coupons", { params });
  return unwrapData<PaginatedResponse<ManageCoupon>>(response);
};

export const getManageCoupon = async (id: number): Promise<ManageCoupon> => {
  const response = await api.get(`/admin/coupons/${id}`);
  return unwrapData<ManageCoupon>(response);
};

export const createManageCoupon = async (
  payload: Record<string, any>,
): Promise<ManageCoupon> => {
  const response = await api.post("/admin/coupons", payload);
  return unwrapData<ManageCoupon>(response);
};

export const updateManageCoupon = async (
  id: number,
  payload: Record<string, any>,
): Promise<ManageCoupon> => {
  const response = await api.put(`/admin/coupons/${id}`, payload);
  return unwrapData<ManageCoupon>(response);
};

export const deleteManageCoupon = async (id: number): Promise<Record<string, any>> => {
  const response = await api.delete(`/admin/coupons/${id}`);
  return unwrapData<Record<string, any>>(response);
};

